module.exports = __webpack_public_path__ + "images/fairPlayIcon-be6f3a87f93cd62a6276267adf79f43f.svg";